import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  submitAssessmentEvaluations,
  type SubmitAssessmentEvaluationsParams,
} from 'api/admin/coach/submitAssessmentEvaluations'
import { coachKeys } from './keys'

export const useSubmitAssessmentEvaluationsMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: SubmitAssessmentEvaluationsParams) =>
      submitAssessmentEvaluations(params),
    onSuccess: async (_data, { positionId, userId }) => {
      await queryClient.invalidateQueries({
        queryKey: coachKeys.assessmentDetail(positionId, userId),
      })
    },
  })
}
